import * as z from "zod/v4";

export const sendTestMobileMessage = {
  name: "sendTestMobileMessage" as const,
  input: z.object({
    fromPhone: z.string(),
    toPhone: z.string(),
    message: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    requestId: z.string().optional(),
    error: z.string().optional(),
  }),
};
